const storageKey = '04:viewed-product-ids:v1';
let viewedProducts = [];
try {
  const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
  if (Array.isArray(stored)) viewedProducts = stored.filter((id) => typeof id === 'string');
} catch {}

const productId = document.body.dataset.cart04ProductId;
if (productId) {
  viewedProducts = [...viewedProducts.filter((id) => id !== productId), productId].slice(-200);
  try {
    localStorage.setItem(storageKey, JSON.stringify(viewedProducts));
  } catch {}
}

class CartSuggestions04 extends HTMLElement {
  connectedCallback() {
    this.renderSuggestions();
    window.addEventListener('pageshow', this.renderSuggestions);
    window.addEventListener('storage', this.renderSuggestions);
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.renderSuggestions);
    window.removeEventListener('storage', this.renderSuggestions);
  }

  renderSuggestions = () => {
    let history = viewedProducts;
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) history = stored;
    } catch {}
    const seen = new Set(history);
    let shown = 0;
    for (const candidate of this.querySelectorAll('[data-cart04-candidate]')) {
      const eligible = candidate.dataset.cart04Excluded !== 'true' && !seen.has(candidate.dataset.cart04Candidate);
      candidate.hidden = !eligible || shown >= 2;
      if (!candidate.hidden) shown += 1;
    }
    this.hidden = shown === 0;
  };
}

if (!customElements.get('cart-suggestions-04')) customElements.define('cart-suggestions-04', CartSuggestions04);
